import { useToken } from '@/app/hooks';
import { useMyProfile } from '@/app/hooks/user/myprofile';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';
import { useEffect } from 'react';
import { useIsMobile } from './CalVW';
import { API_URL } from '@/app/constants/APIKEYS';

const UnloadLog = () => {
  const { token } = useToken();
  const { userIp } = useUserLogger();
  const { data: user } = useMyProfile();
  const isMobile = useIsMobile();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers.Authorization = 'Bearer ' + token;
  }

  const body = {
    userid: user?.id,
    log: USER_LOG_TYPE.UNLOAD,
    data: USER_LOG_TYPE.UNLOAD,
    platform: isMobile ? 'M' : 'W',
    ip: userIp?.ip,
  };

  useEffect(() => {
    if (!token) return;

    const handleBeforeUnload = async () => {
      try {
        await fetch(API_URL + '/system/log', {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
          keepalive: true,
        });
      } catch (error) {
        console.log('error', error);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [token, user?.id, isMobile, userIp?.ip]);

  return null;
};

export default UnloadLog;
